var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require("@/assets/img/chatbot-error.png"),"alt":_vm.$t('images.Chatbot_alt'),"height":"140","tabindex":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }